import {
    ChangeDetectionStrategy,
    Component,
    ContentChildren,
    ElementRef,
    EventEmitter,
    HostBinding,
    Input,
    Output,
    QueryList,
    ViewChild,
} from "@angular/core";
import { AttributePresenceInput } from "@spscommerce/ng-utils";
import * as nanoidImport from "nanoid";

import { SpsDropdownOptionComponent } from "../dropdown-option/sps-dropdown-option.component";

// Some imports need this to work in all contexts incl ng-packagr/rollup
const nanoid = (<any>nanoidImport).default || nanoidImport;

@Component({
    selector: "sps-checkbox-dropdown",
    templateUrl: "./sps-checkbox-dropdown.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpsCheckboxDropdownComponent {
    static readonly displayName = "sps-checkbox-dropdown";
    static readonly props = {
        checked: "boolean",
        checkedChange: { event: true, type: "boolean" },
        indeterminate: "boolean",
        indeterminateChange: { event: true, type: "boolean" },
        disabled: "boolean",
    };

    @Input() id = nanoid();

    @Input() checked = false;
    @Output() checkedChange = new EventEmitter<boolean>();

    @Input() indeterminate = false;
    @Output() indeterminateChange = new EventEmitter<boolean>();

    @Input() @AttributePresenceInput() disabled: boolean;

    @HostBinding("class.sps-checkbox-dropdown") readonly _spsCheckboxDropdownClass = true;

    @ViewChild("checkbox", { static: false }) checkbox: ElementRef<HTMLInputElement>;
    @ContentChildren(SpsDropdownOptionComponent) _options: QueryList<SpsDropdownOptionComponent>;

    _onCheckboxChange() {
        this.checked = this.checkbox.nativeElement.checked;
        this.checkedChange.emit(this.checked);
        this.indeterminate = false;
        this.indeterminateChange.emit(this.indeterminate);
    }
}
